import OrderSettingsLayout from 'bento-ordering/menus/layouts/OrderSettingsLayout';
import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import OrderSettingRouteContainer from 'bento-ordering/menus/containers/OrderSettingRouteContainer';
import MenuItemDetailContainer from 'bento-ordering/menus/containers/MenuItemDetailContainer';
import MenuItemPageLayout from 'bento-ordering/menus/layouts/MenuItemLayout';
import MenuLayout from 'bento-ordering/menus/layouts/MenuLayout';
import MenuUpsellItemDescriptionContainer from 'bento-ordering/cart/containers/MenuUpsellItemDescriptionContainer';

import {
  MENU_BASE,
  MENU_ORDER_SETTING,
  MENU_ITEM_DETAIL,
  UPSELL_MENU_ITEM_DETAIL
} from 'bento-ordering/menus/constants/paths';

const routes = [
  {
    path: MENU_BASE,
    exact: true,
    Component: MenuContainer,
    Layout: MenuLayout
  },
  {
    path: MENU_ORDER_SETTING,
    exact: true,
    Component: OrderSettingRouteContainer,
    Layout: OrderSettingsLayout
  },
  {
    path: MENU_ITEM_DETAIL,
    exact: true,
    Component: MenuItemDetailContainer,
    Layout: MenuItemPageLayout
  },
  {
    path: UPSELL_MENU_ITEM_DETAIL,
    exact: true,
    Component: MenuUpsellItemDescriptionContainer,
    Layout: MenuItemPageLayout
  }
];

export default routes;
